const errorCoding = {
  BAD_SESSION_KEY: {
    code: 'M0023',
    backendDesc: 'INVALID OR BAD SEARCH/SESSION KEY',
    desc: 'When the session key sent in airSearchDisplay request is invalid'
  }
}

export { errorCoding }
